export default __webpack_public_path__ + "56ab21c72a47138da1d1a6befc5fa022.woff";